import axios, { type AxiosInstance, type InternalAxiosRequestConfig } from 'axios';
import { env } from '@/lib/env';
import { useAuthStore } from '@/auth/store';

const attachAuth = (config: InternalAxiosRequestConfig) => {
  const { accessToken, studioId } = useAuthStore.getState();
  if (accessToken) {
    config.headers.set('Authorization', `Bearer ${accessToken}`);
  }
  if (studioId) {
    config.headers.set('X-Studio-Id', studioId);
  }
  return config;
};

const handle401 = async (error: unknown) => {
  if (axios.isAxiosError(error) && error.response?.status === 401) {
    useAuthStore.getState().clear();
  }
  return Promise.reject(error);
};

const make = (baseURL: string): AxiosInstance => {
  const instance = axios.create({ baseURL, timeout: 30_000 });
  instance.interceptors.request.use(attachAuth);
  instance.interceptors.response.use((r) => r, handle401);
  return instance;
};

export const lexApi = make(env.apiBaseUrl);
export const dataroomApi = make(env.dataroomBaseUrl);
